<div class="welcome-page-footer">
    <a class="footer-hyperlink" href="https://aumico.io" target="_blank">aumico.io</a>
    <a
        class="footer-hyperlink"
        href="{{ localizationKeys.aumico_reports_welcome_page_footer_about_link | i18next }}"
        target="_blank"
        >{{ localizationKeys.aumico_reports_welcome_page_footer_about | i18next }}</a
    >
    <a
        class="footer-hyperlink"
        href="{{ localizationKeys.aumico_reports_welcome_page_footer_privacy_policy_link | i18next }}"
        target="_blank"
        >{{ localizationKeys.aumico_reports_welcome_page_footer_privacy_policy | i18next }}</a
    >
    <a
        class="footer-hyperlink"
        href="{{ localizationKeys.aumico_reports_welcome_page_footer_impressum_link | i18next }}"
        target="_blank"
        >{{ localizationKeys.aumico_reports_welcome_page_footer_imprint | i18next }}</a
    >
</div>
